import type { FC } from 'react';

import ArrowIosRight from '@crehana/compass.icons.outline/ArrowIosRight';
import { clsx } from 'clsx';

import { useCrehanaTranslation } from '@/views/LearnDashboard/hooks/useCrehanaTranslation';

import type { BreadcrumbProps, TBreadcrumbPropsMobile } from './type';

const BreadcrumbDesktop: FC<
  TBreadcrumbPropsMobile & Pick<BreadcrumbProps, 'items'>
> = ({ items, itemClass, goToPath, homeUrl }) => {
  const { t } = useCrehanaTranslation();
  return (
    <>
      <li className="tw-font-body5 breadcrumb-item" key="home">
        <a
          className={itemClass}
          href={homeUrl}
          onClick={ev => goToPath(ev, homeUrl)}
        >
          {t('LABEL_SIDEBAR_ITEM_START')}
        </a>
      </li>
      {items?.map((item, index) => {
        const isLast = index === items.length - 1;
        const hasLink = !!item.href;

        return [
          <li
            key={(index * 1).toString()}
            aria-hidden
            className={clsx('tw-mx-0.8', itemClass)}
          >
            <ArrowIosRight className="tw-fill-current " size={16} />
          </li>,
          <li
            key={item.label.toLocaleLowerCase().replace(/ /g, '-')}
            aria-current="page"
            aria-label={item.label}
          >
            {isLast || !hasLink ? (
              <span
                className={clsx(itemClass, {
                  'tw-text-primary-light-500 dark:tw-text-secondary-dark-500':
                    item.isSelect && isLast,
                })}
              >
                {item.label}
              </span>
            ) : (
              <a
                className={clsx(itemClass, {
                  'tw-text-primary-light-500 dark:tw-text-secondary-dark-500':
                    item.isSelect && isLast,
                })}
                href={item.href}
                onClick={ev => goToPath(ev, item.href!)}
              >
                {item.label}
              </a>
            )}
          </li>,
        ];
      })}
    </>
  );
};

export default BreadcrumbDesktop;
